import request from '@/utils/request'

function unwrap(response) {
  const result = response.data
  if (result && result.code === 0) {
    return result
  }
  throw new Error((result && result.msg) || '内部车/黑名单服务请求失败')
}

export function listInternalCars(params) {
  return request({
    url: '/parking99.listInternalCars',
    method: 'get',
    params
  }).then(unwrap)
}

export function saveInternalCar(data) {
  return request({
    url: '/parking99.saveInternalCar',
    method: 'post',
    data
  }).then(unwrap)
}

export function updateInternalCar(data) {
  return request({
    url: '/parking99.updateInternalCar',
    method: 'post',
    data
  }).then(unwrap)
}

export function deleteInternalCar(data) {
  return request({
    url: '/parking99.deleteInternalCar',
    method: 'post',
    data
  }).then(unwrap)
}

export function listBlacklists(params) {
  return request({
    url: '/parking99.listBlacklists',
    method: 'get',
    params
  }).then(unwrap)
}

export function saveBlacklist(data) {
  return request({
    url: '/parking99.saveBlacklist',
    method: 'post',
    data
  }).then(unwrap)
}

export function updateBlacklist(data) {
  return request({
    url: '/parking99.updateBlacklist',
    method: 'post',
    data
  }).then(unwrap)
}

export function deleteBlacklist(data) {
  return request({
    url: '/parking99.deleteBlacklist',
    method: 'post',
    data
  }).then(unwrap)
}
